/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard Service
 * This is the API documentation of the Dashboard service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CompanyUpdateRequest
 */
export interface CompanyUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof CompanyUpdateRequest
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyUpdateRequest
     */
    logo?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyUpdateRequest
     */
    heroImage?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyUpdateRequest
     */
    color?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyUpdateRequest
     */
    license?: string;
}

/**
 * Check if a given object implements the CompanyUpdateRequest interface.
 */
export function instanceOfCompanyUpdateRequest(value: object): value is CompanyUpdateRequest {
    return true;
}

export function CompanyUpdateRequestFromJSON(json: any): CompanyUpdateRequest {
    return CompanyUpdateRequestFromJSONTyped(json, false);
}

export function CompanyUpdateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompanyUpdateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'logo': json['logo'] == null ? undefined : json['logo'],
        'heroImage': json['heroImage'] == null ? undefined : json['heroImage'],
        'color': json['color'] == null ? undefined : json['color'],
        'license': json['license'] == null ? undefined : json['license'],
    };
}

export function CompanyUpdateRequestToJSON(json: any): CompanyUpdateRequest {
    return CompanyUpdateRequestToJSONTyped(json, false);
}

export function CompanyUpdateRequestToJSONTyped(value?: CompanyUpdateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'logo': value['logo'],
        'heroImage': value['heroImage'],
        'color': value['color'],
        'license': value['license'],
    };
}

